import type { ComponentProps } from 'react';
import cx from 'classnames';
import type { BlockViewProps } from '@plone/types';
import config from '@plone/registry';
import MaybeWrap from '@plone/volto/components/manage/MaybeWrap/MaybeWrap';

import type { BlogMacroGalleryData } from './schema';
import styles from './styles.module.css';
import Slides from './Slides';
import type { QubicaContentProps } from '../../View/Common/utils';
import type { BlogExpanders } from '../../View/NewsTestimonialsView/NewsTestimonialView';

type BlogMacroGalleryViewProps = Omit<BlockViewProps, 'data' | 'properties'> & {
  data: BlogMacroGalleryData;
  properties: Omit<QubicaContentProps, '@components'> & {
    '@components': BlogExpanders;
  };
};

const View = (props: BlogMacroGalleryViewProps) => {
  const { className, style, data } = props;
  const Container = config.getComponent('Container').component || 'div';

  const Wrapper = (props: ComponentProps<any>) => (
    <Container
      {...props}
      className={cx('block-blog-macro-gallery-container', styles.container)}
    />
  );

  const slides = props.properties['@components'].blog_summary.news_macro_types;

  return (
    <section
      className={cx('block-blog-macro-gallery', styles.block, className)}
      style={style}
      aria-label={data.title}
    >
      {/* @ts-expect-error */}
      <MaybeWrap condition={!data?.styles?.fullwidth} as={Wrapper}>
        {slides?.length > 0 ? (
          <>
            <Slides slides={slides} editMode={false} />
          </>
        ) : (
          <div className={styles.slidesPlaceholder}>placeholder</div>
        )}
      </MaybeWrap>
    </section>
  );
};
export default View;
